/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateCustomDetectionRuleRequestBody,
  UpdateCustomDetectionRuleRequestBody$Outbound,
  UpdateCustomDetectionRuleRequestBody$outboundSchema,
} from "../components/updatecustomdetectionrulerequestbody.js";

export type UpdateCustomDetectionRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateCustomDetectionRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateCustomDetectionRuleSecurity = {
  option1?: UpdateCustomDetectionRuleSecurityOption1 | undefined;
  option2?: UpdateCustomDetectionRuleSecurityOption2 | undefined;
};

export type UpdateCustomDetectionRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateCustomDetectionRuleRequestBody: UpdateCustomDetectionRuleRequestBody;
};

/** @internal */
export type UpdateCustomDetectionRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateCustomDetectionRuleSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateCustomDetectionRuleSecurityOption1$Outbound,
    UpdateCustomDetectionRuleSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateCustomDetectionRuleSecurityOption1ToJSON(
  updateCustomDetectionRuleSecurityOption1:
    UpdateCustomDetectionRuleSecurityOption1,
): string {
  return JSON.stringify(
    UpdateCustomDetectionRuleSecurityOption1$outboundSchema.parse(
      updateCustomDetectionRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateCustomDetectionRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateCustomDetectionRuleSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateCustomDetectionRuleSecurityOption2$Outbound,
    UpdateCustomDetectionRuleSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateCustomDetectionRuleSecurityOption2ToJSON(
  updateCustomDetectionRuleSecurityOption2:
    UpdateCustomDetectionRuleSecurityOption2,
): string {
  return JSON.stringify(
    UpdateCustomDetectionRuleSecurityOption2$outboundSchema.parse(
      updateCustomDetectionRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateCustomDetectionRuleSecurity$Outbound = {
  Option1?: UpdateCustomDetectionRuleSecurityOption1$Outbound | undefined;
  Option2?: UpdateCustomDetectionRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateCustomDetectionRuleSecurity$outboundSchema: z.ZodMiniType<
  UpdateCustomDetectionRuleSecurity$Outbound,
  UpdateCustomDetectionRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateCustomDetectionRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateCustomDetectionRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateCustomDetectionRuleSecurityToJSON(
  updateCustomDetectionRuleSecurity: UpdateCustomDetectionRuleSecurity,
): string {
  return JSON.stringify(
    UpdateCustomDetectionRuleSecurity$outboundSchema.parse(
      updateCustomDetectionRuleSecurity,
    ),
  );
}

/** @internal */
export type UpdateCustomDetectionRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateCustomDetectionRuleRequestBody:
    UpdateCustomDetectionRuleRequestBody$Outbound;
};

/** @internal */
export const UpdateCustomDetectionRuleRequest$outboundSchema: z.ZodMiniType<
  UpdateCustomDetectionRuleRequest$Outbound,
  UpdateCustomDetectionRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateCustomDetectionRuleRequestBody:
      UpdateCustomDetectionRuleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateCustomDetectionRuleRequestBody:
        "UpdateCustomDetectionRuleRequestBody",
    });
  }),
);

export function updateCustomDetectionRuleRequestToJSON(
  updateCustomDetectionRuleRequest: UpdateCustomDetectionRuleRequest,
): string {
  return JSON.stringify(
    UpdateCustomDetectionRuleRequest$outboundSchema.parse(
      updateCustomDetectionRuleRequest,
    ),
  );
}
